// summaryReducer
import { createSlice } from "@reduxjs/toolkit";

const summarySlice = createSlice({
  name: "summary",
  initialState: {
    selectedScenarios: [],
    referenceScenarioId: null,
    fetchingDataForScenarios: [],
  },
  reducers: {
    setSelectedScenarios: (state, action) => {
      return {
        ...state,
        selectedScenarios: action.payload,
      };
    },
    resetSelectedScenarios: (state) => {
      return {
        ...state,
        selectedScenarios: [],
      };
    },
    setReferenceScenarioId: (state, action) => {
      return {
        ...state,
        referenceScenarioId: action.payload,
      };
    },
    setFetchingDataForScenarios: (state, action) => {
      return {
        ...state,
        fetchingDataForScenarios: action.payload,
      };
    },
  },
});

// Extract the action creators object and the reducer
const { actions, reducer } = summarySlice;

// Extract and export each action creator by name
export const {
  setSelectedScenarios,
  resetSelectedScenarios,
  setReferenceScenarioId,
  setFetchingDataForScenarios,
} = actions;

// Export the reducer, either as a default or named export
export default reducer;
